const scriptsService = require("./../../services/scriptsService");
const RecaptchaComponent = require("./recaptcha.component");

const RecaptchaService = function () {
    const onRecaptchaLoad = new Promise((resolve, reject) => {
        window.onRecaptchaLoad = function () {
            resolve();
        }
    });

    function createRecaptcha($recaptchaContext, siteKey) {
        scriptsService.loadScript("https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit")
            .then(() => onRecaptchaLoad)
            .then(function () {
                const recaptcha = new RecaptchaComponent();
                recaptcha.init($recaptchaContext, {siteKey: siteKey});
            })
            .catch(console.log)
    }

    this.init = function ($recaptchaContext, siteKey) {
        createRecaptcha($recaptchaContext, siteKey);
    };

    return this;
};

module.exports = RecaptchaService;
